import React, { useEffect, useRef } from 'react';
import { observer } from 'mobx-react';

import form from 'modules/ticketPublicPage/stores/vouchers/form';
import view from 'modules/ticketPublicPage/stores/vouchers/view';

import Initial from './Initial';
import ContactDetails from './ContactDetails';
import PaymentDetails from './PaymentDetails';
import Confirmation from './Confirmation';
import Action from './common/Action';
import {
  Container,
  FormContainer,
  NotAvailableMessage,
} from './styles/_buyVoucher';
import Header from './Header';

const BuyVoucher = () => {
  const stepContainerRef = useRef(null);
  const { step, INITIAL, CONTACT_DETAILS, PAYMENT_DETAILS, CONFIRMATION } =
    form;
  const { activeObject } = view;

  useEffect(() => {
    if (stepContainerRef.current && step !== INITIAL) {
      stepContainerRef.current.focus();
    }
  }, [step, INITIAL]);

  const renderForm = () => {
    switch (step) {
      case INITIAL:
        return <Initial />;
      case CONTACT_DETAILS:
        return <ContactDetails />;
      case PAYMENT_DETAILS:
        return <PaymentDetails />;
      case CONFIRMATION:
        return <Confirmation />;
    }
  };

  const ariaContainerLabel =
    step === INITIAL
      ? i18n.gettext('Voucher Purchase')
      : step === CONTACT_DETAILS
        ? i18n.gettext('Contact Details')
        : step === PAYMENT_DETAILS
          ? i18n.gettext('Payment Details')
          : step === CONFIRMATION
            ? i18n.gettext('Voucher purchase confirmation')
            : '';

  return (
    <Container
      role="region"
      tabIndex={0}
      aria-label={ariaContainerLabel}
      aria-live="assertive"
      ref={stepContainerRef}
    >
      {step !== CONFIRMATION && <Header />}
      <FormContainer>
        {activeObject.status === 'active' ? (
          <React.Fragment>{renderForm()}</React.Fragment>
        ) : (
          <NotAvailableMessage>
            <div>
              {i18n.gettext(
                'We are sorry, but currently we do not sell vouchers.'
              )}
            </div>
            <div>
              {i18n.gettext(
                "Please don't hesitate to contact us if you have any questions!"
              )}
            </div>
          </NotAvailableMessage>
        )}
      </FormContainer>
      <Action />
    </Container>
  );
};

export default observer(BuyVoucher);
